/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./style/index.scss?vue&type=style&index=0&id=767ee346&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-767ee346"]])

export default __exports__